import {
  selectActiveSubprofileId,
  selectPrincipalUserId,
} from "../../../sous-profile/redux/selectors/sousProfileSelectors";

export const resolveMedicalScope = (state, target) => {
  const isExplicitTarget = target && typeof target === "object";
  const requestedId = typeof target === "object" ? target?.userId : target;
  const explicitSubprofileId = typeof target === "object" ? target?.subprofileId : null;
  const explicitPrincipalUserId = typeof target === "object" ? target?.principalUserId : null;
  const sessionSubprofileId = selectActiveSubprofileId(state);
  const requestedUserId = String(requestedId ?? "").trim();
  const activeSubprofileId = explicitSubprofileId ||
    (isExplicitTarget || String(sessionSubprofileId ?? "") === requestedUserId
      ? sessionSubprofileId
      : null);
  const principalUserId = explicitPrincipalUserId ||
    (activeSubprofileId ? selectPrincipalUserId(state) : null);
  const userId = activeSubprofileId && principalUserId
    ? String(principalUserId).trim()
    : requestedUserId;

  return {
    userId,
    headers: activeSubprofileId
      ? {
          "X-Subprofile-Id": String(activeSubprofileId),
          "X-Acting-Subprofile-Id": String(activeSubprofileId),
        }
      : {},
  };
};